import { useContext } from 'react';

import { NavigationContext } from './NavigationBar';

import FormListContainer from './Forms/FormListContainer';
import FormSubmitsContainer from './Forms/FormSubmitsContainer';
import FormIncompleteSubmitsContainer from './Forms/FormIncompleteSubmitsContainer';
import FavoriteContainer from './Forms/FavoriteContainer';

function Main() {
  const navigation = useContext(NavigationContext);
  return (
    <div style={{ paddingBottom: 104 }}>
      {navigation === 0 && <FormListContainer />}
      {navigation === 1 && <FormSubmitsContainer />}
      {navigation === 2 && <FormIncompleteSubmitsContainer />}
      {navigation === 3 && <FavoriteContainer />}
    </div>
  );
}

export default Main;
